"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuidv1 = require("uuid/v1");
class SessionUtils {
    static GenerateId() {
        return uuidv1();
    }
}
exports.SessionUtils = SessionUtils;
//# sourceMappingURL=SessionUtils.js.map